// @ts-nocheck
import React from "react";
const ColorModeContext = React.createContext({
    toggleColorMode: () => { },
    defaultMode: () => { },
    togglePrimaryTheme: () => { },
});
export default ColorModeContext;
